import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import { observer } from 'mobx-react'
import {observable} from 'mobx'
import { extendObservable } from 'mobx'
import RadioButton from './formElements/RadioButton'
import HorizontalSingleAxis from './formElements/HorizontalSingleAxis'
import { getPrintPreview } from './utils'
//import '../../assets/css/singleChoice.css';

@observer
export default class SingleChoice extends Component {

    @observable overflow = false
    @observable el

	constructor(props){
		super(props)
		this.handleChange = this.handleChange.bind(this)
		this.buildListItems = this.buildListItems.bind(this)
		this.singleChoiceRef = React.createRef()
		this.width = props.store.printMode
            ? 145
            : 161 // px
		this.marginRight = props.store.printMode
            ? 6
            : 14 // px
		this.state = {
			screenTooSmall: false
		}
	}

	componentDidMount = () => {
		const copyOfState = { ...this.state }
		if ( this.isScreenTooSmall()) {
			copyOfState.screenTooSmall = true
			this.setState(copyOfState)
		}
	}

	isScreenTooSmall = () => {
		/**
		 * If 6 answer do not fit within the questionConatiner
		 * display regular vertical style questions
		 * marginRight is one component less as SCSS removes the 
		 * 6th(nth-child) components margin
		 */
		if ((this.width * 6) + (this.marginRight * 5) > this.singleChoiceRef.current.clientWidth) {
			console.log('screen is too small', this.singleChoiceRef.current.clientWidth, this.width, this.marginRight);
			return true
		}
		return false
	}

	handleChange(option, e) {
		const {
			question,
			store,
		} = this.props
		const value = e.target.value
		store.addFormResponse(question, value, option)
	}

	buildListItems(){
		const {question, store} = this.props
		const set = question.optionSet
		const options = set.options
		return options.filter(o => o.willDisplay !== false).map((option, idx) => {
            if (option.isHidden) {
                return null
            } else {
                return (
					<RadioButton
						idx={idx}
						checked={option.checked}
						key={option.id}
						option={option}
						question={question}
						store={store}
						other={option.hasOwnProperty("hasOptionOther") ? option.hasOptionOther : null}
						handleChange={this.handleChange}
						mode="normal"
					/>
				)
            }
		})
	}
    
    render() {
		var content
		const { question, store, printMode } = this.props
		const dspHorizontal = 
			question.settings.frontend.hasOwnProperty("alignment") 
			&& question.settings.frontend.alignment === "H" 
			&& !store.displayForMobile() 
				? true : false
        if(!dspHorizontal || this.state.screenTooSmall) {
			const listItems = this.buildListItems();
			const { displayCols } = question.settings.frontend					
			content = (
				<div
					style={{ columns: (displayCols > 1) ? displayCols : 'auto'} }
					className={`single-multiple-choice-vertical-con ${(displayCols > 1) ? 'single-multiple-choice-vertical-con--columns' : ''}`}
				>
					{listItems}
				</div>
			)
		} else {
			content = (
				<HorizontalSingleAxis
					width={this.width}
					marginRight={this.marginRight}
					store={store}
					question={question}
					handleChange={this.handleChange}
				/>
			)
		}
		return (
			<div ref={this.singleChoiceRef}>
                {getPrintPreview(question, store)}
                {content}
			</div>
		)
	}
}
